export enum ErrorEnum {
    TECHNICAL = '101_technical_error',
    GENERATING = '104_generating_error',
    LOW_BANDWIDTH = '105_low_bandwidth_error',
    VIDEO_UNAVAILABLE = '108_video_unavailable_error',
    VIDEO_NOT_FOUND = '109_video_not_found_error',
    INCOMPATIBLE_BROWSER = '112_incompatible_browser_error',
    CREDITS_UNAVAILABLE = '113_credits_unavailable_error',
    RESOLUTION_GENERATING_ERROR = 'resolution_generating_error',
    HIGH_TRAFFIC_ERROR = 'high_traffic_error'
}
